import React from "react";
import { Text, View, StyleSheet, TouchableOpacity } from "react-native";

import appStyles from "../../../appStyles";
import ElementIcon from "../../elements/list/ElementIcon";

export default function TimeslotElements(props) {
  const {
    timeslot,
    //editMode = false,
    showUnchunkIcon = false,
    onPress = () => {},
    onLongPress = () => {},
    isBulkEdit = false,
    selectedElementIds,
  } = props;

  const onElementSelected = (element) => {
    if (isBulkEdit) {
      onPress(element, selectedElementIds?.has(element.id));
    } else {
      onPress();
    }
  };

  const { activity, activity2, activity3 } = timeslot;
  //const canBeUndone = !editMode && timeslot.undo_activity;
  const enableMultipleActivities = true;

  let activities = [activity];
  if (enableMultipleActivities) {
    if (activity2) activities.push(activity2);
    if (activity3) activities.push(activity3);
  }

  const isMultiTasking = activities.length > 1;
  const highlight = isBulkEdit && isMultiTasking;

  return (
    <View style={styles.container}>
      {activities.map((activity, index) => (
        <TouchableOpacity
          key={index}
          onPress={() => onElementSelected(activity)}
          onLongPress={onLongPress}
          style={[
            styles.element,
            highlight
              ? selectedElementIds?.has(activity.id)
                ? styles.checked
                : styles.unchecked
              : {},
          ]}
        >
          {/* Element icon */}
          <ElementIcon
            element={activity}
            onPress={() => onElementSelected(activity)}
            onLongPress={onLongPress}
            style={
              isMultiTasking
                ? { marginLeft: 0, marginRight: 2, paddingHorizontal: 0 }
                : showUnchunkIcon
                ? { marginLeft: 0 }
                : {}
            }
          />

          {/* Name */}
          <Text
            numberOfLines={2}
            style={[
              //canBeUndone ? appStyles.activityNameUndo : appStyles.activityName, Removed 2021.11.03
              appStyles.activityName,
              timeslot.isSelected && appStyles.selectedTimeslotText,
            ]}
          >
            {activity.name}
          </Text>
        </TouchableOpacity>
      ))}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: "row",
  },
  element: {
    flexDirection: "row",
    alignItems: "center",
    flex: 1,
    paddingVertical: 3,
    paddingHorizontal: 4,
    marginRight: 7,
  },
  checked: {
    borderRadius: 4,
    backgroundColor: "#F6EC91",
  },
  unchecked: {
    borderRadius: 4,
    backgroundColor: "#F3F2F1",
  },
});
